import { createSlice } from '@reduxjs/toolkit';
import {
  importProductUpdate
} from '../thunk/productThunk';

const initialState = {
  productsName: null,
  planError: null,
  loading: false,
  error: null,
  importProductUpdateLoading: false,
  importProductUpdateRes: null,
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(importProductUpdate.pending, (state) => {
        state.importProductUpdateLoading = true;
        state.error = null;
      })
      .addCase(importProductUpdate.fulfilled, (state, action) => {
        state.importProductUpdateLoading = false;
        state.importProductUpdateRes = action.payload;
      })
      .addCase(importProductUpdate.rejected, (state, action) => {
        state.importProductUpdateLoading = false;
        state.importProductUpdateRes = null;
        state.error = action.payload;
      });
  },
});

export default productSlice.reducer;
